import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import classNames from 'classnames';
import styles from '../styles/entity-highlights-widget.module.scss';
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const EntityHighlightsWidgetAsyncComponent = AsyncComponent(async () => import('./entity-highlights-widget' /* webpackChunkName: "entity-highlights-widget" */ ));

export const EntityHighlightsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={!props.isPreview}>
    <React.Suspense fallback={<div className={classNames(styles.placeholder)}><LoadingIndicator/></div>}>
      <EntityHighlightsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
